module.exports = __webpack_public_path__ + "static/media/etat-medicament-grey.3e4eddc2.svg";